import { request } from './repository';

const url = 'comments/';

const commentsRepository = {
    getComments(params) {
        return request.get(url, params);
    },
    getServiceComments(service_id) {
        return this.getComments({
            service_id: service_id
        });
    },
    storeComment(service_id, content) {
        return request.post(url, {
          service_id: service_id,
          content: content
        });
    },
    deleteComment(id){
        return request.delete(url + id);
    }
}

export default commentsRepository;
